function displayErrors(resp, self) {
    const fallbackMessage = resp?.statusText || `Request failed${resp?.status ? ` (${resp.status})` : ''}`;
    const body = resp?.body || {};
    const detail = body.detail;

    if (body.errors && typeof body.errors === 'object') {
        self.errors = body.errors;
        return true;
    }

    if (Array.isArray(detail)) {
        for (const item of detail) {
            const keys = Array.isArray(item?.loc) ? item.loc : [];
            let key = keys.length ? keys[keys.length - 1] : "__all__";
            if (key === "body") key = "__all__";
            self.errors[key] = [item?.msg || fallbackMessage];
        }
    } else if (typeof detail === "string" && detail.length) {
        self.errors = {'__all__': [detail]};
    } else if (body.state === undefined || body.state === false) {
        self.errors = {'__all__': [fallbackMessage]};
    }
    return true;
}

function stringToHexColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
    }
    return "#" + [
        ((hash << 5 | hash >> 27) & 0xff),
        ((hash << 3 | hash >> 29) & 0xff),
        ((hash << 10 | hash >> 22) & 0xff)
    ].map(v => v.toString(16).padStart(2, '0')).join("")
}

export { displayErrors, stringToHexColor };
